import { useCallback, useEffect, useRef, useState } from "react";
import api from "@/lib/api";

export const TYPES = {
  poll: "Scelta multipla",
  wordcloud: "Nuvola di parole",
  scale: "Scala 1–5",
  open: "Domanda aperta",
};
export const COLORS = ["#38bdf8", "#a78bfa", "#f472b6", "#34d399", "#fb923c", "#facc15", "#60a5fa", "#f87171"];
export const yellowBtn = "bg-[#E3FF00] text-[#09090b] font-semibold rounded-xl border border-[#c0eb00] hover:bg-[#cbff00] active:scale-[0.98] transition-[background-color,transform] inline-flex items-center justify-center gap-2 disabled:opacity-50";

const wsUrl = (code) => `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/airep/ws/${code}`;

export function useLiveState(code, path) {
  const [state, setState] = useState(null);
  const [error, setError] = useState(null);
  const modeRef = useRef("realtime");
  const seq = useRef(0);
  const load = useCallback(async () => {
    const n = ++seq.current;
    try {
      const { data } = await api.get(path);
      if (n !== seq.current) return;
      modeRef.current = data.mode;
      setState(data);
      setError(null);
    } catch (e) { setError(e?.response?.data?.detail || "Errore di connessione"); }
  }, [path]);
  useEffect(() => {
    if (!code) return undefined;
    load();
    let ws = null;
    let wsOk = false;
    try {
      ws = new WebSocket(wsUrl(code));
      ws.onopen = () => { wsOk = true; };
      ws.onmessage = () => { if (modeRef.current === "realtime") load(); };
      ws.onerror = () => { wsOk = false; };
      ws.onclose = () => { wsOk = false; };
    } catch { wsOk = false; }
    const t = setInterval(() => {
      if (modeRef.current === "poll" || !wsOk) load();
    }, 1500);
    const slow = setInterval(load, 3000);
    return () => { clearInterval(t); clearInterval(slow); if (ws) ws.close(); };
  }, [code, load]);
  return { state, error, reload: load };
}

export const textOn = (hex) => {
  const h = (hex || "#E3FF00").replace("#", "");
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? "#09090b" : "#ffffff";
};
export const brandPalette = (brand) => {
  const c = brand?.colors || {};
  const own = [c.primary, c.secondary, c.accent].filter(Boolean);
  return own.length ? [...own, ...COLORS] : COLORS;
};

export async function downloadFile(url, filename) {
  const { data } = await api.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
